import { render, staticRenderFns } from "./InputCustomerType.vue?vue&type=template&id=c4d4ad90&scoped=true"
import script from "./InputCustomerType.vue?vue&type=script&lang=js"
export * from "./InputCustomerType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d4ad90",
  null
  
)

export default component.exports